import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StockorderproductDashboard from '../StockorderproductDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import StockorderproductPageImpl from './StockorderproductPageImpl';

export default function StockorderproductPage() {
    const {mobileView} = useSelector((state)=>state.menu);
    const dispatch = useDispatch();
    const { stockorderproductList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!mobileView}));
    },[]);

    return (
        < StockorderproductPageImpl />
    )

}